import Cookies from "js-cookie";

//https://ssp-dev-react.moreconnect.in/gmb
//https://ssp-prod.moreconnect.in/gmb

export const useIsGmbAdmin = () => {
  const role = Cookies.get("ssp_role");
  const isDev = window.location.host.includes("localhost") || window.location.host.includes("dev");
  
  if(!isDev){
    return role === "1345";
  } 
  if(isDev){
    return  role === "1081";
  }
};
